module.exports = __webpack_public_path__ + "static/media/referralIcon.383af18e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/referralIcon.png
// module id = 1106
// module chunks = 1